import { Component, OnInit } from '@angular/core';
import { MediaObj } from 'src/app/models/models';

@Component({
  selector: 'videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.css']
})
export class VideosComponent implements OnInit {
  videos: MediaObj[] = [];
  search: String = "";
  filteredVideos: MediaObj[] = [];
  noVideos: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.filteredVideos = this.videos;
  }

  filterVideos(){
    if(this.search.length==0)
      this.filteredVideos = this.videos;
    else{
      this.filteredVideos = [];
      this.videos.forEach(v=> {
        let s1 = v.title.toLowerCase() + ' ' + v.description.toLowerCase() +
        ' ' + v.date.toISOString();
        let s2 = this.search.toLowerCase();
        if(s1.includes(s2)){
          this.filteredVideos.push(v);
        }
      });
    }

  }
}
